// extracted by mini-css-extract-plugin
export var textInput = "_g3-0";